document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pfu-customer-videos__video-wrap').forEach(function (wrap) {
    const video = wrap.querySelector('video');
    const playButton = wrap.querySelector('.pfu-customer-videos__play');

    if (!video) return;

    function playVideo(event) {
      if (event) event.preventDefault();

      video.controls = true;

      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(function () {});
      }

      wrap.classList.add('is-playing');
    }

    wrap.addEventListener('click', function (event) {
      if (video.paused || video.ended) {
        playVideo(event);
      }
    });

    video.addEventListener('click', function (event) {
      if (video.paused || video.ended) {
        event.preventDefault();
        event.stopPropagation();
        playVideo(event);
      }
    });

    if (playButton) {
      playButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        playVideo(event);
      });
    }

    video.addEventListener('play', function () {
      video.controls = true;
      wrap.classList.add('is-playing');
    });

    video.addEventListener('pause', function () {
      wrap.classList.remove('is-playing');
    });

    video.addEventListener('ended', function () {
      video.controls = false;
      wrap.classList.remove('is-playing');
    });
  });
});